// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.invalid-label,
.valid-label {
  margin-top: 0;
  margin-bottom: 4px;
}

.invalid-label {
  color: red;
}

.valid-label {
  color: #3e7e00;
}

img {
  opacity: 0.2;
}`, "",{"version":3,"sources":["webpack://./src/modules/@boxx/boxx-images/lib/components/image-fixer/invalid-images-fixer.component.scss"],"names":[],"mappings":"AAAA;;EAEE,aAAA;EACA,kBAAA;AACF;;AACA;EACE,UAAA;AAEF;;AAAA;EACE,cAAA;AAGF;;AAAA;EACE,YAAA;AAGF","sourcesContent":[".invalid-label,\n.valid-label {\n  margin-top: 0;\n  margin-bottom: 4px;\n}\n.invalid-label {\n  color: red;\n}\n.valid-label {\n  color: #3e7e00;\n}\n\nimg {\n  opacity: 0.2;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
